import { reactive } from 'vue'
import { addUser } from '@/helpers/tokenStorage'

type Data = {
  bgColor?: string
  title?: string
  busine?: string
  color?: string
  description?: string
  logo?: string
  timeAttendance?: string
  token?: string
}

export type StoreState = {
  currentComponent: string;
  previusComponent: string;
  attendance: {
    id: number
    unreadMessages: number
  }
  name: string;
  email: string;
  apiKey: string;
  apiId: number;
  user: string;
  currentPage: string;
  urlBase: string
  wsToken: string
  data: Data;
  businessId: number;
  channel : number;
}

const initialState: StoreState = {
  currentComponent: 'SelectStart',
  previusComponent: 'SelectStart',
  businessId: 0,
  channel: 0,
  attendance: {
    id: 0,
    unreadMessages: 0
  },
  email: '',
  name: '',
  user: '',
  apiKey: '',
  apiId: 0,
  currentPage: '',
  urlBase: '',
  wsToken: '',
  data: {
    logo: '',
    title: 'Olá, seja bem vindo!',
    description: 'Em que possamos te ajudar?',
    timeAttendance: 'Menos de 10 minutos',
    busine: '',
    color: '#00BCD4',
    token: ''
  }
}

const state = reactive<StoreState>({ ...initialState })

export function setCurrentComponent (component: string): void {
  state.previusComponent = state.currentComponent
  state.currentComponent = component
}

export function setBusiness (busine: number): void {
  state.businessId = busine
}

export function setChannel (channel: number): void {
  state.channel = channel
}

export function setApiId (api: number): void {
  state.apiId = api
}

export function setData (data: Data): void {
  state.data = data
}

export function setEmail (email: string): void {
  state.email = email
}

export function setName (name: string): void {
  state.name = name
}

export function setCurrentPage (page: string): void {
  state.currentPage = page
}

export function setApiKey (apiKey: string): void {
  state.apiKey = apiKey
}

export function setUser (user: string): void {
  addUser(user)
  state.user = user
}

export function setAttendance (attendance: number): void {
  state.attendance.id = attendance
}

export function setWebSocketToken (token: string | null): void {
  if (!token) return

  state.wsToken = token
}

export function setUrlBase (url: string): void {
  state.urlBase = url
}

export function sumUnreadMessages () {
  if (state.attendance.unreadMessages === 99) return
  state.attendance.unreadMessages++
}

export function resetStore (): void {
  setCurrentComponent(initialState.currentComponent)
  setEmail(initialState.email)
  setName(initialState.name)
  setCurrentPage(initialState.currentPage)
  setApiKey(initialState.apiKey)
  setUser(initialState.user)
  setBusiness(initialState.businessId)
  setChannel(initialState.channel)
  setUrlBase(initialState.urlBase)
  setAttendance(initialState.attendance.id)
}

export function setState(data: StoreState): void {
    if(data?.currentComponent) {
        setCurrentComponent(data.currentComponent)
    }
    if(data?.businessId) {
        setBusiness(data.businessId)
    }
    if(data?.channel) {
        setChannel(data.channel)
    }
    if(data?.attendance?.id) {
        setAttendance(data.attendance.id)
    }
    if(data?.attendance?.unreadMessages) {
        state.attendance.unreadMessages = data.attendance.unreadMessages
    }
    if(data?.email) {
        setEmail(data.email)
    }
    if(data?.name) {
        setName(data.name)
    }
    if(data?.user) {
        setUser(data.user)
    }
    if(data?.apiKey) {
        setApiKey(data.apiKey)
    }
    if(data?.apiId) {
        setApiId(data.apiId)
    }
    if(data?.currentPage) {
        setCurrentPage(data.currentPage)
    }
    if(data?.urlBase) {
        setUrlBase(data.urlBase)
    }
    if(data?.wsToken) {
        setWebSocketToken(data.wsToken)
    }
    if(data?.data) {
        setData(data.data)
    }
}

export default state
